import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import JsonViewer from '@/components/JsonViewer'
import { useTranslation } from 'react-i18next'

export interface ViewMetadataModalProps extends ModalProps {
    metadata: any
    taskId: number
}

const ViewMetadataModal: React.FC<ViewMetadataModalProps> = ({
    onClose,
    open,
    metadata,
    taskId,
}) => {
    const { t } = useTranslation()

    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={`${t('metadata-details')} - Task #${taskId}`}
            maxWidth="md"
        >
            <JsonViewer data={metadata} />
        </Dialog>
    )
}

export default ViewMetadataModal
